import { cities, neighborhoods } from '../data';

const PROPERTY_TYPE_LABELS: Record<string, string> = {
  apartment: 'דירת מגורים',
  duplex: 'דופלקס',
  penthouse: 'פנטהאוז',
  'garden-apartment': 'דירת גן',
  house: 'בית פרטי',
  commercial: 'מסחרי',
};

const CONDITION_LABELS: Record<string, string> = {
  renovated_high: 'משופץ ברמה גבוהה',
  renovated: 'משופץ',
  good: 'שמור',
  original: 'מצב מקורי',
  needs_renovation: 'דורש שיפוץ',
  unknown: 'לא ידוע',
};

const cityLabelMap = new Map<string, string>();
for (const c of cities) {
  cityLabelMap.set(c.value, c.label);
  cityLabelMap.set(c.label, c.label);
}

const neighborhoodLabelMap = new Map<string, string>();
for (const cityKey of Object.keys(neighborhoods)) {
  for (const n of neighborhoods[cityKey]) {
    neighborhoodLabelMap.set(n.value, n.label);
    neighborhoodLabelMap.set(n.label, n.label);
  }
}

export function displayCity(slug: string | undefined): string | undefined {
  if (!slug) return undefined;
  return cityLabelMap.get(slug) || slug;
}

export function displayCityArray(slugs: string[] | undefined): string[] {
  if (!slugs || slugs.length === 0) return [];
  return slugs.map(s => displayCity(s) || s);
}

export function displayNeighborhood(slug: string | undefined): string | undefined {
  if (!slug) return undefined;
  return neighborhoodLabelMap.get(slug) || slug;
}

export function displayNeighborhoodArray(slugs: string[] | undefined): string[] {
  if (!slugs || slugs.length === 0) return [];
  return slugs.map(s => displayNeighborhood(s) || s);
}

export function displayPropertyType(slug: string | undefined): string | undefined {
  if (!slug) return undefined;
  return PROPERTY_TYPE_LABELS[slug] || slug;
}

export function displayPropertyTypeArray(slugs: string[] | undefined): string[] {
  if (!slugs || slugs.length === 0) return [];
  return slugs.map(s => displayPropertyType(s) || s);
}

export function displayCondition(slug: string | undefined): string | undefined {
  if (!slug) return undefined;
  return CONDITION_LABELS[slug] || slug;
}

export function displayConditionArray(slugs: string[] | undefined): string[] {
  if (!slugs || slugs.length === 0) return [];
  return slugs.map(s => displayCondition(s) || s);
}
